import utagLinkGeneric from './utagLinkGeneric';

function trackSortH1 () {

	// find first h1 on the page
	const h1 = document.querySelector('#lpContainer h1');
	const { isHospitality } = window.lp.globals;
	const { pathname, search } = window.location;
	const {
		isFreeTextSearch, isImageSearch, isShopByTrend, isShopByRoom
	} = window.lp.pageData;
	// sort page (e.g. not PLA iframe - /popups/QuickLook.aspx)
	const isSortPage = /\/[cs]\/.+$/gi.test(pathname);
	const isClearanceOrSale = /((clearance|onsale)_view)|ds_daily-savings/gi.test(pathname);
	const isSubsequentPage = /\/page_.+$/gi.test(pathname);
	const isMobile = window.utag_data && window.utag_data.is_mobile;

	// abandon if no h1
	if (!h1) {

		return;

	}

	if (
		isSortPage
		&& !isHospitality
		&& !isShopByRoom
		&& !isShopByTrend
		&& !isClearanceOrSale
		&& !isFreeTextSearch
		&& !isImageSearch
		&& !isSubsequentPage
	) {

		let copyH1;

		if (/^\/[cs]\/sales_open-box\//.test(pathname)) {

			const h1Selector = isMobile === '1'
				? '#lpContainer .heading h1, #lpContainer .openBoxHeading'
				: '#lpContainer #SortPageH1Tag';
			copyH1 = document.querySelector(h1Selector).cloneNode(true);

		} else {

			copyH1 = h1.cloneNode(true);

		}

		const resultTag = copyH1.querySelector('.result');

		if (resultTag) {

			copyH1.removeChild(resultTag);

		}

		const value = copyH1.textContent.replace(/\s+/g, ' ').trim();

		window.setTimeout(() => {

			utagLinkGeneric({
				eventCategory: 'Sort',
				eventAction: `H1 - ${value}`,
				eventLabel: `${pathname}${search}`,
				nonInteraction: 1
			});

		}, 0);

	}

}

export default trackSortH1;
